<div class="header layout-corral">
  <a [routerLink]="rootPage?.link" class="logo">
    Русское&nbsp;общество управления&nbsp;рисками
  </a>
  <a class="burger" (click)="openMobileMenu()">
    <ico ico="menu_24" [size]="36" color="#FFF"></ico>
  </a>


  <pages-menu class="lvl-0"></pages-menu>

  <div class="inline center">
    <locale></locale>
    <a class="btn vnii" href="" target="_blank">!!!!!!!!!!</a>
  </div>
  
</div>
